import { Box, Grid, Link } from '@material-ui/core';
import React from 'react';
import logoAgeas from '../../assets/images/footer/logos/ageas.webp';
import logoAMPorto from '../../assets/images/footer/logos/amporto.webp';
import logoBrandStore from '../../assets/images/footer/logos/brandstore.webp';
import logoElCorteIngles from '../../assets/images/footer/logos/elcorteingles.webp';
import logoEstrellaGalicia from '../../assets/images/footer/logos/estrellagalicia.webp';
import logoEU from '../../assets/images/footer/logos/eu.webp';
import logoNorte2030 from '../../assets/images/footer/logos/norte2030.webp';
import logoPorto from '../../assets/images/footer/logos/porto.webp';
import logoPortoCanal from '../../assets/images/footer/logos/portocanal.webp';
import logoPT2030 from '../../assets/images/footer/logos/pt2030.webp';
import logoRepPT from '../../assets/images/footer/logos/rep_pt.webp';
import { Config } from '../../services/Config';
import styles from './Supporters.module.scss';

export default function Supporters() {
    return (
        <Grid container justify="center" className={styles.Wrapper}>
            <Grid
                container
                component="section"
                justify="space-between"
                alignItems="flex-start"
                className={styles.Section}
            >

                <Box className={styles.Block}>
                    <div className={styles.Category}>
                        <span className={styles.Title}>
                            Parceiros<br />Institucionais
                        </span>
                        <div className={styles.LogoRow}>
                            <img src={logoRepPT} alt="República Portuguesa" className={styles.Rep} />
                            <img src={logoPorto} alt="Porto." />
                            <img src={logoAMPorto} alt="AMPorto" className={styles.AMPorto} />
                        </div>
                    </div>

                    <div className={styles.Category}>
                        <span className={styles.Title}>
                            Naming<br />Partner
                        </span>
                        <div className={styles.LogoRow}>
                            <img src={logoAgeas} alt="Grupo Ageas Portugal" className={styles.Ageas} />
                        </div>
                    </div>

                    <div className={styles.Category}>
                        <span className={styles.Title}>
                            Patrocinador<br />Oficial
                        </span>
                        <div className={styles.LogoRow}>
                            <img src={logoEstrellaGalicia} alt="Estrella Galicia" />
                        </div>
                    </div>

                    <div className={styles.Category}>
                        <span className={styles.Title}>
                            Apoio<br />Divulgação
                        </span>
                        <div className={styles.LogoRow}>
                            <img src={logoPortoCanal} alt="Porto Canal" className={styles.PortoCanal} />
                        </div>
                    </div>

                    <div className={styles.Category}>
                        <span className={styles.Title}>
                            &nbsp;<br />
                            Apoios
                        </span>
                        <div className={styles.LogoRow}>
                            <img src={logoElCorteIngles} alt="El Corte Inglês" className={styles.ElCorteIngles} />
                            <img src={logoBrandStore} alt="Brand Store" className={styles.BrandStore} />
                        </div>
                    </div>
                </Box>

                <Box className={`${styles.Block} ${styles.Funding}`}>
                    <div className={styles.Category}>
                        <span className={styles.Title}>
                            &nbsp;<br />
                            Cofinanciamento
                        </span>
                        <div className={styles.LogoRow}>
                            <Link href={Config.FOOTER_PDF} target="_blank" rel="noopener">
                                <img src={logoNorte2030} alt="Norte 2030" />
                            </Link>
                            <Link href={Config.FOOTER_PDF} target="_blank" rel="noopener">
                                <img src={logoPT2030} alt="Portugal 2030" />
                            </Link>
                            <Link href={Config.FOOTER_PDF} target="_blank" rel="noopener">
                                <img src={logoEU} alt="União Europeia" />
                            </Link>
                        </div>
                        <span className={styles.FundingNote}>
                            Clique nos logótipos para mais informações
                        </span>
                    </div>
                </Box>
            </Grid>
        </Grid>
    );
}
